module.exports = __webpack_public_path__ + "img/part-1-title.f7f3e360.png";